import { fillerBenchmarks } from './helpers/content';

const findBenchmarkAndUpdate = (updatedBenchmark, benchmarks) => {
  const indexOfBenchmark = benchmarks.findIndex(item => item.id === updatedBenchmark.id);

  const updatedItems = [...benchmarks];
  updatedItems[indexOfBenchmark] = updatedBenchmark;
  return updatedItems;
};

const findFirstHiddenBenchmarkAndShowIt = benchmarks => {
  const indexOfHiddenBenchmark = benchmarks.findIndex(item => item.isVisible === false);
  const updatedBenchmarks = [...benchmarks];

  updatedBenchmarks[indexOfHiddenBenchmark] = {
    ...updatedBenchmarks[indexOfHiddenBenchmark],
    isVisible: true
  };
  return updatedBenchmarks;
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATED_WIDGET':
      return {
        ...state,
        ...action.payload
      };
    case 'UPDATE_BENCHMARK':
      return {
        ...state,
        benchmarks: findBenchmarkAndUpdate(action.payload, state.benchmarks)
      };
    case 'UPDATE_BENCHMARK_VISIBILITY':
      return {
        ...state,
        benchmarks: findFirstHiddenBenchmarkAndShowIt(state.benchmarks)
      };

    default:
      return state;
  }
};

const generateEmptyRecord = benchmarks => {
  if (benchmarks && benchmarks.length && benchmarks.length > 0) {
    const enrichedBenchmarks = [...benchmarks].map((benchmark, index) => ({
      ...benchmark,
      id: fillerBenchmarks[index].id,
      isVisible: !!benchmark.benchmarkId
    }));
    return [...enrichedBenchmarks, ...fillerBenchmarks.slice(benchmarks.length)];
  }

  return fillerBenchmarks;
};

export const generateInitialWidgetState = ({
  benchmarks,
  masterObjectId,
  masterObjectTypeId,
  dateRangeTypeId,
  endDate,
  startDate
}) => {
  return {
    masterObjectTypeId: masterObjectTypeId || 1,
    widgetOverlayId: null,
    shouldInheritBenchmarks: benchmarks?.length > 0,
    masterObjectId,
    overlayDropdown: null,
    title: '',
    benchmarks: generateEmptyRecord(benchmarks),
    isLegendDisplayed: true,
    isTitleDisplayed: true,
    isDateDisplayed: true,
    isChartTooltipDisplayed: true,
    endDate: endDate || null,
    startDate: startDate || null,
    dateRangeTypeId,
    dateMatchType: 2
  };
};

export const actions = {
  UPDATED_WIDGET: 'UPDATED_WIDGET',
  UPDATE_BENCHMARK: 'UPDATE_BENCHMARK',
  UPDATE_BENCHMARK_VISIBILITY: 'UPDATE_BENCHMARK_VISIBILITY'
};
